import { useRef, useState } from "react";
import EnterpriseFormView from "./enterprise-form-view/enterprise-form-view";
import "./enterprise-interest-page.scss";
import SelectRoleView from "./select-role-view/select-role-view";



type PageModeType = "role-selection" | "enterprise-form" | "service-provider-form"

const EnterpriseInterestPage = () => {

    const pageWrapperRef = useRef<HTMLDivElement>(null)

    const [pageMode, setPageMode] = useState<PageModeType>("role-selection")


    return (<div className="enterprise-interest-page" ref={pageWrapperRef}>
        <section>
            {pageMode === "role-selection" && <SelectRoleView onSelect={(type: PageModeType) => setPageMode(type)} />}
            {pageMode === "enterprise-form" && <EnterpriseFormView />}
        </section>
    </div>)
}
export default EnterpriseInterestPage